var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12.449 7.254 8.617 3.422a.75.75 0 0 1 1.06-1.06l5.103 5.103.01.01a.75.75 0 0 1 0 1.06l-5.112 5.112a.75.75 0 0 1-1.061-1.06l3.832-3.833H1.753a.75.75 0 1 1 0-1.5z",
  clipRule: "evenodd"
})));
export default SvgArrow;